export const CREATE_FLASH_MESSAGE = 'CREATE_FLASH_MESSAGE'
export const CLEAR_FLASH_MESSAGES = 'CLEAR_FLASH_MESSAGES'
